import React, { FunctionComponent } from 'react';

import Flex, { FlexProps } from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';
import useTranslation from '../../../translations/useTranslation';

export const FileQuery = graphql`
  query {
    appStore: file(relativePath: { eq: "app-store.png" }) {
      childImageSharp {
        gatsbyImageData(height: 40, quality: 80)
      }
    }
    googlePlay: file(relativePath: { eq: "google-play.png" }) {
      childImageSharp {
        gatsbyImageData(height: 40, quality: 80)
      }
    }
  }
`;

export type FileQueryProps = {
  appStore: {
    childImageSharp: {
      gatsbyImageData: GatsbyImageProps['image'];
    };
  };
  googlePlay: {
    childImageSharp: {
      gatsbyImageData: GatsbyImageProps['image'];
    };
  };
};

const useStyles = () => {
  const { spacing, breakpoint } = useTheme();
  return {
    google: {
      margin: spacing(0, 0, 2, 0),
      [breakpoint.up('md')]: {
        margin: spacing(0, 4, 0, 0),
      },
    },
  };
};

const Buttons: FunctionComponent<FlexProps<'div'>> = (props) => {
  const { appStore, googlePlay } = useStaticQuery<FileQueryProps>(FileQuery);
  const t = useTranslation();
  const classes = useStyles();

  return (
    <Flex justifyContent="center" alignItems="center" flexDirection={{ xs: 'column', md: 'row' }} {...props}>
      <a
        href="https://play.google.com/store/apps/details?id=com.gojob.fog"
        target="_blank"
        aria-label={t('download_application_google_play_store')}
        rel="noopener noreferrer"
        css={classes.google}
      >
        <GatsbyImage
          loading="lazy"
          alt={t('download_application_google_play_store')}
          image={googlePlay?.childImageSharp?.gatsbyImageData}
        />
      </a>
      <a
        href="https://itunes.apple.com/app/apple-store/id1454242491"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('download_application_ios_app_store')}
      >
        <GatsbyImage
          loading="lazy"
          alt={t('download_application_ios_app_store')}
          image={appStore.childImageSharp.gatsbyImageData}
        />
      </a>
    </Flex>
  );
};

export default Buttons;
